import SettingsCard from "../SettingsCard"
import { updatePerVisitRecurringPayment } from "../../Proposals/paymentScheduleModel"
import { useState } from "react"
import InvoiceRateSelector from "../../Proposals/PaymentOptions/InvoiceRateSelector"
import { PaymentScheduleOptions } from "../../../domain/proposals/settings/proposalSettings"
import { useUpdatePaymentScheduleOptionsMutation } from "../../../domain/proposals/settings/proposalSettingsQueries"
import { isEqual } from "lodash"

type Props = {
  serverOptions: PaymentScheduleOptions
}

const PerVisitSettings = ({serverOptions}: Props) => {
  const [paymentScheduleOptions, setPaymentScheduleOptions] = useState<PaymentScheduleOptions>(serverOptions)
  const updateProposalSettingsMutation = useUpdatePaymentScheduleOptionsMutation()
  const dataToSave = {
    ...serverOptions,
      perVisit: paymentScheduleOptions.perVisit
  }
  const hasChanges = !isEqual(dataToSave, serverOptions)

  return <SettingsCard
    title="Invoicing Schedule for Per Visit"
    description="Set the default payment schedule for work areas priced Per Visit. This schedule will be included in proposals automatically."
    onUpdate={() => updateProposalSettingsMutation.mutate(dataToSave)}
    isUpdating={updateProposalSettingsMutation.isLoading}
    updateDisabled={!hasChanges}
  >
    <InvoiceRateSelector
      recurringPayment={paymentScheduleOptions.perVisit.recurring}
      onChange={value => setPaymentScheduleOptions(updatePerVisitRecurringPayment(paymentScheduleOptions, value))}
      hideEstimatedStartDate
    />
  </SettingsCard>
}

export default PerVisitSettings
